export default function PreferenceLevel({
    label,
    value,
    onChange
}) {

    return (
        <tr>

            <td classNma="fontmontserrat" style={{ width: "60%" }}>{label}</td>

            <td className="u-align-center" style={{ width: "10%" }}>
                <input
                    type="radio"
                    name={label}
                    checked={value === "low"}
                    onChange={() => onChange("low")}
                    required
                />
            </td>

            <td className="u-align-center" style={{ width: "10%" }}>
                <input
                    type="radio"
                    name={label}
                    checked={value === "medium"}
                    onChange={() => onChange("medium")}
                    required
                />
            </td>

            <td className="u-align-center" style={{ width: "10%" }}>
                <input
                    type="radio"
                    name={label}
                    checked={value === "high"}
                    onChange={() => onChange("high")}
                    required
                />
            </td>

        </tr>
    );
}
